import React from 'react';
import {connect} from "react-redux";
import autobind from 'autobind-decorator';
import {createBrowserRouter, RouterProvider, Outlet} from 'react-router-dom';
import {DragDropContext} from 'react-beautiful-dnd';
import './icons';

import {service as ConservationActionTypeService} from "./Services/ConservationActionTypeService";
import {service as OrganizationService} from "./Services/OrganizationService";

import {
	StreamBankErrorDisplayEnhance,
} from "./Components/Common/Enhancements/StreamBankErrorDisplayEnhance";
import {    
    StreamBankLoaderIconDisplayEnhance
} from "./Components/Common/Enhancements/StreamBankLoaderIconDisplayEnhance";
import {    
    StreamBankSessionTimeoutCheckerEnhance,
} from "./Components/Common/Enhancements/StreamBankSessionTimeoutCheckerEnhance";

import {StreamBankToolRouter} from "./Components/Common/StreamBankToolRouter";

import {LoginPage} from './Components/Pages/Login/LoginPage';
import {ForgotPasswordPage} from './Components/Pages/Login/ForgotPasswordPage';

import {ContactsViewPage} from './Components/Pages/Contacts/ViewPage';
import {UsersViewPage} from './Components/Pages/Users/ViewPage';
import {UsersSubscriptionsPage} from './Components/Pages/Users/SubscriptionsPage';
import {SurveysViewPage} from './Components/Pages/Surveys/ViewPage';
import {UsersIndexPage} from './Components/Pages/Users/IndexPage';
import {SurveysIndexPage} from './Components/Pages/Surveys/IndexPage';
import {CustomListIndexPage} from './Components/Pages/SpeciesLists/CustomLists/CustomListIndexPage';
import {CustomListViewPage} from './Components/Pages/SpeciesLists/CustomLists/CustomListViewPage';
import {GlobalSpeciesPage} from './Components/Pages/SpeciesLists/GlobalList/GlobalSpeciesPage';
import {SecureDownloadPage} from './Components/Pages/SecureDownload/Page';
import {QueryToolIndexPage} from './Components/Pages/QueryTool/IndexPage';
import {ServiceDrivenViewPage} from "./Components/Common/ServiceDrivenViewPage";
import {ServiceDrivenIndexPage} from "./Components/Common/ServiceDrivenIndexPage";
import {SpeciesRequestsPage} from "./Components/Pages/SpeciesLists/SpeciesRequests/SpeciesRequestsPage";

import {LibraryRedirectPage} from "./Components/Pages/Library/LibraryRedirectPage";

const OrganizationViewPageComponent = ServiceDrivenViewPage(OrganizationService);
const OrganizationIndexPageComponent = ServiceDrivenIndexPage(OrganizationService);
const ConservationActionTypeViewPageComponent = ServiceDrivenViewPage(ConservationActionTypeService);
const ConservationActionTypeIndexPageComponent = ServiceDrivenIndexPage(ConservationActionTypeService);

import {Header} from "./Components/Layout";
import {Footer} from "./Components/Layout";

import {SET_DRAG_DROP} from "./Redux/Actions/Types";
import {LogoutPage} from "./Components/Pages/Login/LogoutPage";
import {ReportBuilderIndexPage} from "./Components/Pages/ReportBuilder/IndexPage";

@StreamBankSessionTimeoutCheckerEnhance
@StreamBankErrorDisplayEnhance
@StreamBankLoaderIconDisplayEnhance
class _StreamBankApp extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            error: null,
        };
    }

    @autobind
    onDragStart() {}

    @autobind
    onDragUpdate() {}

    @autobind
    onDragEnd(result) {
        this.props.setDragDrop(result);
    }

    render() {
        const { error } = this?.state || {};

        if(error) {
            //TODO: Setup a better error page.
            return <span>
                An unrecoverable error has occurred. Please refresh the page and try again.
            </span>;
        }

        return <DragDropContext
            onDragStart={this.onDragStart}
            onDragUpdate={this.onDragUpdate}
            onDragEnd={this.onDragEnd}
        >
            <Header />
            <Outlet />
            <Footer />
        </DragDropContext>;
    }
}

const mapDispatchToProps = dispatch => ({
    setDragDrop: result => {
        dispatch({type: SET_DRAG_DROP, result});
    }
});

const AppLayout = connect(null, mapDispatchToProps)(_StreamBankApp);

const routeDefinitions = [
    {path: '/', element: <StreamBankToolRouter />},
    {path: '/login', element: <LoginPage />},
    {path: '/logout', element: <LogoutPage />},
    {path: '/forgotPassword', element: <ForgotPasswordPage />},
    {path: '/files/download/:fileId/:fileName?', element: <SecureDownloadPage />},
    {path: '/users/subscriptions', element: <UsersSubscriptionsPage />},
    {path: '/users/:userId', element: <UsersViewPage />},
    {path: '/organizations/:organizationId', element: <OrganizationViewPageComponent />},
    {path: '/surveys/:surveyId', element: <SurveysViewPage />},
    {path: '/users', element: <UsersIndexPage />},
    {path: '/organizations', element: <OrganizationIndexPageComponent />},
    {path: '/surveys', element: <SurveysIndexPage />},
    {path: '/speciesLists/:speciesListId', element: <CustomListViewPage />},
    {path: '/speciesLists', element: <CustomListIndexPage />},
    {path: '/allSpecies', element: <GlobalSpeciesPage />},
    {path: '/speciesRequests', element: <SpeciesRequestsPage />},
    {path: '/query', element: <QueryToolIndexPage />},
    {path: '/reportBuilder', element: <ReportBuilderIndexPage />},
    {path: '/conservationActionTypes/:conservationActionTypeId', element: <ConservationActionTypeViewPageComponent />},
    {path: '/conservationActionTypes', element: <ConservationActionTypeIndexPageComponent />},
    {path: '/library', element: <LibraryRedirectPage />},
    {path: '/:pProgId/:cProgId/:projId/contacts/:conId', element: <ContactsViewPage />},
    {path: '/:pProgId/:cProgId/contacts/:conId', element: <ContactsViewPage />},
    {path: '/:pProgId/contacts/:conId', element: <ContactsViewPage />},
    {path: '/contacts/:conId', element: <ContactsViewPage />},
    {path: '/:pProgId/:cProgId/:projId/:conActId/:sampleEventId/:tool', element: <StreamBankToolRouter />},
    {path: '/:pProgId/:cProgId/:projId/:conActId/:tool', element: <StreamBankToolRouter />},
    {path: '/:pProgId/:cProgId/:projId/:tool', element: <StreamBankToolRouter />},
    {path: '/:pProgId/:cProgId/:tool', element: <StreamBankToolRouter />},
    {path: '/:pProgId/:tool', element: <StreamBankToolRouter />},
    {path: '/:tool', element: <StreamBankToolRouter />}
];

const router = createBrowserRouter([
    {
        element: <AppLayout />,
        children: routeDefinitions
    }
]);

export const StreamBankApp = () => <RouterProvider router={router} />;
